import styled, { css } from 'styled-components';

import {
    Button,
    ButtonGroup,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

export const StyledCTAComponent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        flex-direction: column;
    `)}
`;

export const StyledButtonGroup = styled(ButtonGroup)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        flex-direction: column-reverse;
    `)}
`;

export const StyledButton = styled(Button)`
    margin-bottom: 0;

    [class^="ButtonGroup"] & + & {
        margin-left: ${spaceMixin('sm')};
    }

    /* 769 */
    ${mediaMixin('lg_eq', css`
        margin-bottom: ${spaceMixin('sm')};

        [class^="ButtonGroup"] & + & {
            margin-left: 0;
        }
    `)}
`;

/* only show at the lg breakpoint */
export const StyledVONContainer = styled.div`
    display: none;

    /* 769 */
    ${mediaMixin('lg_eq', css`
        display: block;
    `)}
`;
